import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "load"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "数据正在加载中，耐心等候一下哦～", -1)

import { watchEffect } from "vue";
  import ballLoad from "@/assets/ballLoad.gif";
  
  const __default__ = {
    name: "Loading",
  };
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loading: Boolean,
  },
  setup(__props) {

const props = __props

  
  watchEffect(() => {
    if (props.loading) {
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--hideden", "hidden");
    }else{
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--hideden", "auto");
    }
  });
  
return (_ctx: any,_cache: any) => {
  return (props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "load-img",
          src: _unref(ballLoad),
          alt: ""
        }, null, 8, _hoisted_2),
        _hoisted_3
      ]))
    : _createCommentVNode("", true)
}
}

})